/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const BOOTSTRAP_CONFIG = {
  servers: {
    graphql: [
      {
        name: "graphql-gateway",
        devurl: "https://kiran.vlinderserver.online/tribe-v2/core/", // Dev server
        // staging
        // url: "https://ca-central-staging-1.klefki.io/tribe/core/", // Staging server
        url: "https://ca-central-1.klefki.io/tribe/core/", // Production server
      },
    ],
    rest: {
      loginServer: {
        devbaseURL: "https://kiran.vlinderserver.online/tribe-v2/login", // Dev server
        //staging
        // baseURL: "https://ca-central-staging-1.klefki.io/tribe/login", // Staging server
        baseURL: "https://ca-central-1.klefki.io/tribe/login", // Production server
      },
    },
  },
};
